module.exports = __webpack_public_path__ + "static/media/email.4c912e8c.svg";